// TODO: From App New
import { get, set } from '@/helper/localStorage'
import _get from 'lodash/get'
import fields from '@/field/table/sale'

export default {
  namespaced: true,
  state: {
    tableFields: get('saleTableFields', fields),
    tableData: [],
    tablePagination: get('saleTablePagination'),
    tableKeyword: get('saleTableKeyword'),
    tableSort: get('saleTableSort'),
    tableFilter: get('saleTableFilter', []),
    detailData: get('saleDetailData'),
    loadingTable: false,
    loadingDetail: false,
    loadingSubmit: false,
    // Merchants data for brand selection
    merchantsData: [],
    merchantsPagination: {
      page: 1,
      total_page: 1,
      limit: 1000,
      total_item: 0,
    },
    loadingMerchants: false,
    // Sale brands data for selected brands in promo
    saleBrandsData: [],
    saleBrandsPagination: {
      page: 1,
      total_page: 1,
      limit: 100,
      total_item: 0,
    },
    loadingSaleBrands: false,
    // Products data for brand products
    productsData: [],
    productsPagination: {
      page: 1,
      total_page: 1,
      limit: 10,
      total_item: 0,
    },
    loadingProducts: false,
  },
  getters: {
    tableFields: state => {
      if (!state.tableFields) {
        return undefined
      }

      // only the visibility is customizable by the user
      const visibilities = state.tableFields.reduce(
        (obj, item) => Object.assign(obj, { [item.key]: item.visibility }), {},
      )

      // the other props uses the default fields configuration
      return fields.map(item => ({
        ...item,
        // only replace the visibility value if user override it
        visibility: item.key in visibilities ? visibilities[item.key] : item.visibility,
      }))
    },
    tableSort: state => {
      if (!state.tableSort) {
        return undefined
      }

      const symbol = state.tableSort.direction === 'desc' ? '-' : ''

      return `${symbol}${state.tableSort.key}`
    },
    tableData: state => {
      if (!state.tableData) {
        return []
      }

      return state.tableData.map(item => ({
        ...item,
        // add or replace field here
      }))
    },
    detailData: state => {
      if (!state.detailData) {
        return undefined
      }

      return {
        ...state.detailData,
        // add or replace field here
      }
    },
    tableFilter: state => {
      if (!state.tableFilter) {
        return []
      }

      return state.tableFilter
        .reduce((acc, elem) => Object.assign(acc, {
          [`filter[${elem.key}]`]: Array.isArray(elem.value)
            ? elem.value.join(',')
            : elem.value,
        }), {})
    },
    tableParams: (state, getters, rootState) => ({
      'filter[keyword]': state.tableKeyword,
      ...getters.tableFilter,
      sort: getters.tableSort,
      page: _get(state, 'tablePagination.current_page', 1),
      limit: rootState.appConfig.settings.tablePerPage,
    }),
  },
  mutations: {
    SET_TABLE_FIELDS(state, val) {
      set('saleTableFields', val)
      state.tableFields = val
    },
    RESET_TABLE_FIELDS(state) {
      set('saleTableFields', fields)
      state.tableFields = fields
    },
    SET_TABLE_DATA(state, val) {
      state.tableData = val
    },
    SET_TABLE_PAGINATION(state, val) {
      set('saleTablePagination', val)
      state.tablePagination = val
    },
    SET_TABLE_KEYWORD(state, val) {
      set('saleTableKeyword', val)
      state.tableKeyword = val
    },
    SET_DETAIL_DATA(state, val) {
      set('saleDetailData', val)
      state.detailData = val
    },
    SET_TABLE_SORT(state, val) {
      set('saleTableSort', val)
      state.tableSort = val
    },
    SET_TABLE_FILTER(state, val) {
      set('saleTableFilter', val)
      state.tableFilter = val
    },
    SET_LOADING_TABLE(state, val) {
      state.loadingTable = val
    },
    SET_LOADING_DETAIL(state, val) {
      state.loadingDetail = val
    },
    SET_LOADING_SUBMIT(state, val) {
      state.loadingSubmit = val
    },
    SET_MERCHANTS_DATA(state, val) {
      state.merchantsData = val
    },
    SET_MERCHANTS_PAGINATION(state, val) {
      state.merchantsPagination = val
    },
    SET_LOADING_MERCHANTS(state, val) {
      state.loadingMerchants = val
    },
    SET_SALE_BRANDS_DATA(state, val) {
      state.saleBrandsData = val
    },
    SET_SALE_BRANDS_PAGINATION(state, val) {
      state.saleBrandsPagination = val
    },
    SET_LOADING_SALE_BRANDS(state, val) {
      state.loadingSaleBrands = val
    },
    SET_PRODUCTS_DATA(state, val) {
      state.productsData = val
    },
    SET_PRODUCTS_PAGINATION(state, val) {
      state.productsPagination = val
    },
    SET_LOADING_PRODUCTS(state, val) {
      state.loadingProducts = val
    },
  },
  actions: {
    getTableData({ commit, getters }) {
      commit('SET_LOADING_TABLE', true)

      const { tableParams: params } = getters

      return this._vm.$http.get('/v1/admin/sales', { params })
        .then(({ data }) => {
          commit('SET_TABLE_DATA', data.data)
          commit('SET_TABLE_PAGINATION', data.meta)
        })
        .finally(() => {
          commit('SET_LOADING_TABLE', false)
        })
    },
    search(_, payload) {
      return this._vm.$http.get('/v1/admin/sales', {
        params: {
          'filter[ids]': payload ? payload.ids : undefined,
          'filter[keyword]': payload ? payload.keyword : undefined,
        },
      })
        .then(({ data }) => data.data)
        .catch(() => [])
    },
    getProductList(_, id) {
      return this._vm.$http.get(`/v1/admin/sales/${id}/products`)
        .then(({ data }) => data.data)
        .catch(() => [])
    },
    getSaleSkus(_, id) {
      return this._vm.$http.get(`/v1/admin/sales/${id}/sale-skus`)
        .then(({ data }) => data.data)
        .catch(() => [])
    },
    createSaleSkus(_, { id, skus }) {
      return this._vm.$http.post(`/v1/admin/sales/${id}/sale-skus`, { skus })
        .then(({ data }) => data.data)
    },
    changeSaleSkusPrice(_, { id, skus }) {
      return this._vm.$http.put(`/v1/admin/sales/${id}/sale-skus/price`, { skus })
        .then(({ data }) => data.data)
    },
    deleteSaleSku(_, { saleId, skuId }) {
      return this._vm.$http.delete(`/v1/admin/sales/${saleId}/skus/${skuId}`)
    },
    getDetail({ commit }, id) {
      commit('SET_LOADING_DETAIL', true)

      return this._vm.$http.get(`/v1/admin/sales/${id}`)
        .then(({ data }) => {
          commit('SET_DETAIL_DATA', data.data)
        })
        .finally(() => {
          commit('SET_LOADING_DETAIL', false)
        })
    },
    create({ commit }, data) {
      commit('SET_LOADING_SUBMIT', true)

      return this._vm.$http.post('/v1/admin/sales', data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    uploadSkus({ commit }, { id, data }) {
      commit('SET_LOADING_SUBMIT', true)

      return this._vm.$http.post(`/v1/admin/sales/${id}/sale-skus`, data)
        .then(res => res.data.data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    update({ commit }, { id, data }) {
      commit('SET_LOADING_SUBMIT', true)

      return this._vm.$http.patch(`/v1/admin/sales/${id}`, data)
        .then(res => {
          commit('SET_DETAIL_DATA', res.data.data)
        })
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    delete({ commit }, id) {
      commit('SET_LOADING_SUBMIT', true)

      return this._vm.$http.delete(`/v1/admin/sales/${id}`)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    getMerchants({ commit }, params = {}) {
      commit('SET_LOADING_MERCHANTS', true)

      // Default parameters for merchants endpoint
      const defaultParams = {
        limit: 1000,
        page: 1,
        ...params,
      }

      return this._vm.$http.get('/v2/admin/merchants', { params: defaultParams })
        .then(({ data }) => {
          if (data.data) {
            commit('SET_MERCHANTS_DATA', data.data)
            commit('SET_MERCHANTS_PAGINATION', data.pagination || {
              page: defaultParams.page,
              total_page: 1,
              limit: defaultParams.limit,
              total_item: data.data.length,
            })
          }
          return data
        })
        .finally(() => {
          commit('SET_LOADING_MERCHANTS', false)
        })
    },
    getSaleBrands({ commit }, id) {
      commit('SET_LOADING_SALE_BRANDS', true)

      return this._vm.$http.get(`/v1/admin/sales/${id}/brands`)
        .then(({ data }) => {
          if (data.status) {
            commit('SET_SALE_BRANDS_DATA', data.data.rows || data.data)
            commit('SET_SALE_BRANDS_PAGINATION', data.data.pagination || {
              page: 1,
              total_page: 1,
              limit: 100,
              total_item: (data.data.rows || data.data).length,
            })
          }
          return data
        })
        .finally(() => {
          commit('SET_LOADING_SALE_BRANDS', false)
        })
    },
    addSaleBrands({ commit }, { id, merchant_ids }) {
      commit('SET_LOADING_SUBMIT', true)

      const payload = {
        merchant_ids,
      }

      return this._vm.$http.post(`/v1/admin/sales/${id}/brands`, payload)
        // Don't auto-update the brands list here since component handles it
        .then(({ data }) => data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    removeSaleBrands({ commit }, { id, merchant_ids }) {
      commit('SET_LOADING_SUBMIT', true)

      const payload = {
        merchant_ids,
      }

      return this._vm.$http.delete(`/v1/admin/sales/${id}/brands`, { data: payload })
        // Don't auto-update the brands list here since component handles it
        .then(({ data }) => data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    searchProducts(_, params = {}) {
      // Default parameters for product search
      const defaultParams = {
        limit: 10,
        page: 1,
        ...params,
      }

      return this._vm.$http.get('/v5/products', { params: defaultParams })
        .then(({ data }) => {
          if (data.status) {
            return data.data.rows || []
          }
          return []
        })
        .catch(() => [])
    },
    addSaleSkus({ commit }, { id, skus }) {
      commit('SET_LOADING_SUBMIT', true)

      const payload = {
        skus,
      }

      return this._vm.$http.post(`/v1/admin/sales/${id}/sale-skus`, payload)
        .then(({ data }) => data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    async getSaleSkusByBrand(_, { id, merchantId }) {
      const allData = []
      const perPage = 100

      // Helper function to create fetch request
      const createFetchRequest = page => {
        const params = {
          page,
          limit: perPage,
        }

        // Only add merchant_id filter if provided
        if (merchantId) {
          params['filter[merchant_id]'] = merchantId
        }

        return this._vm.$http.get(`/v1/admin/sales/${id}/sale-skus`, { params })
          .then(response => ({
            page,
            data: response.data.data || [],
            meta: response.data.meta,
            fullResponse: response.data,
          })).catch(error => ({
            page,
            data: [],
            meta: null,
            error,
          }))
      }

      try {
        // Get first page to get both data and pagination info
        const firstPageResponse = await createFetchRequest(1)

        if (firstPageResponse.error) {
          return []
        }

        if (firstPageResponse.data.length > 0) {
          allData.push(...firstPageResponse.data)
        }

        // Get pagination info from first page response
        const totalPages = firstPageResponse.meta ? firstPageResponse.meta.last_page : 1

        // If there are more pages, fetch them in parallel
        if (totalPages > 1) {
          const fetchRequests = []

          // Create requests for remaining pages (page 2 to last_page)
          for (let page = 2; page <= totalPages; page += 1) {
            fetchRequests.push(createFetchRequest(page))
          }

          // Execute all requests in parallel
          if (fetchRequests.length > 0) {
            const responses = await Promise.all(fetchRequests)

            // Process all responses
            responses.forEach(response => {
              if (response.error) {
                return
              }

              if (response.data.length > 0) {
                allData.push(...response.data)
              }
            })
          }
        }

        return allData
      } catch (error) {
        return []
      }
    },
    deleteSaleSkuById({ commit }, { saleId, skuId }) {
      commit('SET_LOADING_SUBMIT', true)

      return this._vm.$http.delete(`/v1/admin/sales/${saleId}/skus/${skuId}`)
        .then(({ data }) => data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    updateSaleSkuPrice({ commit }, { id, skus }) {
      commit('SET_LOADING_SUBMIT', true)

      const payload = {
        skus,
      }

      return this._vm.$http.put(`/v1/admin/sales/${id}/sale-skus/price`, payload)
        .then(({ data }) => data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    getProductFlags(_, id) {
      return this._vm.$http.get(`/v1/admin/sales/${id}/product-flags`)
        .then(({ data }) => data.data)
        .catch(() => [])
    },
    updateProductFlags({ commit }, { id, productIds }) {
      commit('SET_LOADING_SUBMIT', true)

      const payload = {
        product_ids: productIds,
      }

      return this._vm.$http.post(`/v1/admin/sales/${id}/product-flags`, payload)
        .then(({ data }) => data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    removeProductFlags({ commit }, { id, productIds }) {
      commit('SET_LOADING_SUBMIT', true)

      const payload = {
        product_ids: productIds,
      }

      return this._vm.$http.delete(`/v1/admin/sales/${id}/product-flags`, { data: payload })
        .then(({ data }) => data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    getProductHighlights(_, id) {
      return this._vm.$http.get(`/v1/admin/sales/${id}/product-highlights`)
        .then(({ data }) => data.data)
        .catch(() => [])
    },
    updateProductHighlights({ commit }, { id, productIds }) {
      commit('SET_LOADING_SUBMIT', true)

      const payload = {
        product_ids: productIds,
      }

      return this._vm.$http.post(`/v1/admin/sales/${id}/product-highlights`, payload)
        .then(({ data }) => data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    removeProductHighlights({ commit }, { id, productIds }) {
      commit('SET_LOADING_SUBMIT', true)

      const payload = {
        product_ids: productIds,
      }

      return this._vm.$http.delete(`/v1/admin/sales/${id}/product-highlights`, { data: payload })
        .then(({ data }) => data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    duplicate({ commit }, duplicateData) {
      commit('SET_LOADING_SUBMIT', true)

      const id = typeof duplicateData === 'object' ? duplicateData.id : duplicateData
      const payload = typeof duplicateData === 'object' ? duplicateData.payload : {}

      return this._vm.$http.post(`/v1/admin/sales/${id}/duplicate`, payload)
        .then(({ data }) => data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
  },
}
